const physicalColors = {
  PHYSICAL_50: '#FDE9E6',
  PHYSICAL_100: '#FFCDBA',
  PHYSICAL_200: '#FFAC8D',
  PHYSICAL_800: '#DE4300',
}

export default physicalColors
